import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Badge,
  Box,
} from '@mui/material';
import {
  Dashboard,
  Message,
  CalendarMonth,
  CheckCircle,
  Person,
} from '@mui/icons-material';

export default function PatientBottomNavigation({ unreadMessages = 0, pendingTodos = 0 }) {
  const navigate = useNavigate();
  const location = useLocation();

  // Map routes to navigation values
  const getNavigationValue = () => {
    const path = location.pathname;
    if (path.includes('/patient/dashboard')) return 0;
    if (path.includes('/patient/messages')) return 1;
    if (path.includes('/patient/appointments')) return 2;
    if (path.includes('/patient/todos')) return 3;
    if (path.includes('/patient/profile')) return 4;
    return 0; // Default to dashboard
  };

  const handleNavigationChange = (event, newValue) => {
    const routes = [
      '/patient/dashboard',
      '/patient/messages',
      '/patient/appointments',
      '/patient/todos',
      '/patient/profile',
    ];
    navigate(routes[newValue]);
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        borderTop: 1,
        borderColor: 'divider',
        display: { xs: 'block', md: 'none' }, // Only show on mobile
      }}
      elevation={3}
    >
      <BottomNavigation
        value={getNavigationValue()}
        onChange={handleNavigationChange}
        showLabels
        sx={{
          height: 56,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 0',
            '&.Mui-selected': {
              paddingTop: '6px',
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.75rem',
            '&.Mui-selected': {
              fontSize: '0.75rem',
            },
          },
        }}
      >
        <BottomNavigationAction
          label="Dashboard"
          icon={<Dashboard />}
        />
        <BottomNavigationAction
          label="Messages"
          icon={
            <Badge badgeContent={unreadMessages} color="error">
              <Message />
            </Badge>
          }
        />
        <BottomNavigationAction
          label="Appointments"
          icon={<CalendarMonth />}
        />
        <BottomNavigationAction
          label="Todos"
          icon={
            <Badge badgeContent={pendingTodos} color="warning">
              <CheckCircle />
            </Badge>
          }
        />
        <BottomNavigationAction
          label="Profile"
          icon={<Person />}
        />
      </BottomNavigation>
      {/* Safe area for iOS devices */}
      <Box sx={{ height: 'env(safe-area-inset-bottom, 0)' }} />
    </Paper>
  );
}